"use client";

import type { Message } from "@langchain/langgraph-sdk";
import {
  FetchStreamTransport,
  type UseStreamTransport,
} from "@langchain/langgraph-sdk/react";

import { kyInstance } from "@/api/api-config";

type AskDecodaState = { messages: Message[] } & Record<string, unknown>;

function postSdkStream(
  endpoint: string,
  body: unknown,
  signal?: AbortSignal | null,
  onAccepted?: () => void,
) {
  return kyInstance
    .post(endpoint, {
      body: typeof body === "string" ? body : JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
      signal,
      timeout: false,
      retry: 0,
    })
    .then((response) => {
      if (response.ok) onAccepted?.();
      return response;
    });
}

export function createAskDecodaChatTransport(
  onAccepted?: () => void,
): UseStreamTransport<AskDecodaState> {
  return new FetchStreamTransport<AskDecodaState>({
    apiUrl: "agent/chat",
    fetch: (_url: string, init?: RequestInit) =>
      postSdkStream(
        "agent/chat",
        init?.body,
        init?.signal ?? undefined,
        onAccepted,
      ),
  }) as UseStreamTransport<AskDecodaState>;
}

export type { AskDecodaState };
